
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.263 11.717H1.737A.737.737 0 011 10.981V6.855c0-.406.33-.736.737-.736h22.526c.407 0 .737.33.737.736v4.126c0 .406-.33.736-.737.736zm-21.79-1.473h21.054V7.592H2.473v2.652z"}}),_c('path',{attrs:{"d":"M22.735 25.032H3.265a.737.737 0 01-.737-.736V10.973c0-.407.33-.737.737-.737h19.47c.407 0 .737.33.737.737v13.323c0 .406-.33.736-.737.736zM4.001 23.56H22v-11.85H4v11.85z"}}),_c('path',{attrs:{"d":"M13 25.032a.737.737 0 01-.737-.736V6.856a.737.737 0 011.474 0v17.44c0 .406-.33.736-.737.736z"}}),_c('path',{attrs:{"d":"M17.07 7.592H13a.737.737 0 01-.737-.737c0-2.91 2.034-5.855 5.921-5.855 1.574 0 2.673 1.14 2.673 2.772 0 1.878-1.416 3.82-3.786 3.82zm-3.269-1.473h3.27c.87 0 1.41-.41 1.709-.753.378-.434.603-1.03.603-1.593 0-.486-.156-1.299-1.2-1.299-3.004 0-4.12 2.09-4.382 3.645z"}}),_c('path',{attrs:{"d":"M12.95 7.592H8.879c-2.37 0-3.787-1.942-3.787-3.82 0-.736.232-1.412.652-1.903.34-.396.965-.869 2.022-.869 3.886 0 5.92 2.945 5.92 5.855 0 .407-.33.737-.736.737zM7.766 2.473c-1.044 0-1.2.814-1.2 1.3 0 .973.717 2.346 2.313 2.346h3.27c-.262-1.555-1.379-3.646-4.383-3.646z"}})])
          )
        }
      }
    